import React from "react"
import { useTranslation } from "react-i18next"

import classes from "./HeldOrderCombos.module.scss"

const HeldOrderCombos = props => {
  const { heldOrder } = props

  const [t] = useTranslation()

  return (
    heldOrder.combos.map((combo, cIndex) =>
      <div
        key={cIndex}
        className={classes["combo"]}
      >
        <div className={classes["comboNameContainer"]}>
          <div className={classes["comboName"]}>
            {t("بسته_های_ترکیبی")}{" "}
          </div>
          <div className={classes["comboCode"]}>
            {combo.name}
          </div>
        </div>

        {combo.items.map((comboItem, comboItemIndex) =>
          <div
            key={comboItemIndex}
            className={classes["text"]}
          >
            {comboItem.foodName}{" "}
            {!comboItem.isSimple ? `(${comboItem.optionName})` : ""}{" "}
            <b>{comboItem.quantity}x</b>

          </div>
        )}
      </div>
    )
  )
}

export default HeldOrderCombos